import React from 'react';
import { useMenuBuilder } from '../../context/MenuBuilderContext';
import { cn } from '../../lib/utils';

export const CoordinateDisplay = ({ className }) => {
  const { menuData, selectedAreaIndex } = useMenuBuilder();
  
  const selectedArea = selectedAreaIndex !== null 
    ? menuData.areas[selectedAreaIndex] 
    : null;

  const formatNumber = (num) => {
    return String(num).padStart(4, ' ');
  };

  return (
    <div 
      className={cn(
        "glass-panel rounded-lg p-4",
        className
      )}
      data-testid="coordinate-display"
    >
      <p className="label-text mb-3">Coordinates</p>
      
      {selectedArea ? (
        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="text-[#52525B] text-xs block mb-1">X</span>
            <span className="coordinate-display text-[#00E05E]">
              {formatNumber(selectedArea.bounds.x)}
            </span>
          </div>
          <div>
            <span className="text-[#52525B] text-xs block mb-1">Y</span>
            <span className="coordinate-display text-[#00E05E]">
              {formatNumber(selectedArea.bounds.y)}
            </span>
          </div>
          <div>
            <span className="text-[#52525B] text-xs block mb-1">Width</span>
            <span className="coordinate-display text-[#6366F1]">
              {formatNumber(selectedArea.bounds.width)}
            </span>
          </div>
          <div>
            <span className="text-[#52525B] text-xs block mb-1">Height</span>
            <span className="coordinate-display text-[#6366F1]">
              {formatNumber(selectedArea.bounds.height)}
            </span>
          </div>
        </div>
      ) : (
        <div className="text-[#52525B] text-sm">
          Select an area to view coordinates
        </div>
      )}

      {/* Canvas size info */}
      <div className="mt-4 pt-4 border-t border-[#27272A]">
        <p className="label-text mb-2">Canvas Size</p>
        <p className="font-mono text-sm text-[#A1A1AA]">
          {menuData.size.width} × {menuData.size.height}
        </p>
      </div>
    </div>
  );
};

export default CoordinateDisplay;
